import { AmpPersonalisation } from "types/amplience";

export const isPersonalisedConfig = <T extends { personalization: AmpPersonalisation }>(
  c: T | Omit<T, "personalization">,
): c is T & { personalization: AmpPersonalisation } => Boolean((c as T).personalization);
